export default "__VITE_ASSET__Ca7rlUox__"